import type { WClientTestimonialsCardsTranslations } from "./pl";

export const de: WClientTestimonialsCardsTranslations = {
  defaultTitle: "Was unsere Kunden sagen",
  prev: "Vorherige",
  next: "Nächste",
  goToSlide: "Zur Referenz",
};
